import React from 'react';
import { Link } from 'react-router-dom';
import { bookInfoRo } from '../data/bookDataRo';
import { FiBookOpen } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const FooterRo = () => (
  <footer className="bg-black py-12 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <SafeIcon icon={FiBookOpen} className="text-brand-accent text-xl" />
            <span className="font-display font-bold text-white tracking-wider text-sm uppercase">Trezirea Cuantică</span>
          </div>
          <p className="text-gray-500 text-sm leading-relaxed">
            O Cronică a Ascensiunii Umane de {bookInfoRo.author}
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Navigare</h4>
          <div className="flex flex-col gap-2">
            {[['Acasă', '/ro'], ['Povestea', '/ro/story'], ['Capitole', '/ro/chapters'], ['Autor', '/ro/author']].map(([name, href]) => (
              <Link key={name} to={href} className="text-gray-500 hover:text-brand-accent text-sm transition-colors">{name}</Link>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Cumpără Cartea</h4>
          <div className="flex flex-col gap-2">
            <a href={bookInfoRo.links.amazon.kindle} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-brand-accent text-sm transition-colors">Ediție Kindle</a>
            <a href={bookInfoRo.links.amazon.paperback} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-brand-accent text-sm transition-colors">Broșată</a>
            <a href={bookInfoRo.links.amazon.hardcover} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-brand-accent text-sm transition-colors">Cartonată</a>
            <a href={bookInfoRo.links.website.ro} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-white text-sm transition-colors">Site Autor (RO)</a>
            <a href={bookInfoRo.links.website.en} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-white text-sm transition-colors">Site Autor (EN)</a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 pt-8 text-center text-gray-600 text-sm">
        &copy; {new Date().getFullYear()} {bookInfoRo.author}. Toate drepturile rezervate.
      </div>
    </div>
  </footer>
);

export default FooterRo;